import React, { useEffect } from 'react';
import Loader from '../Shared/Loader/loader';
import { getTenantsByProjectId } from '../../API/Tenant/Tenant';
import { usePropsStoreValue } from '../../Hooks/PropStore/usePropsStore';
import { useTenantsApp } from '../../Context/TenantsApp/TenantsAppContext';
import { SET_LOADING, SET_PROJECT, SET_TENANTS } from './TenantsAppEvents';
import TenantsAppGrid from './TenantsAppGrid';
import DeleteTenantApp from './DeleteTenantApp';
import AppInValidBanner from './AppInValidBanner';
import SyncAllTenantsDialog from './SyncAllTenantsDialog';
import { getProject } from '../../API/Project/project';
import DisableTenantApp from './DisableTenantApp';
import DeleteTenantAppInstance from './DeleteTenantAppInstance';
import DisableTenantAppInstance from './DisableTenantAppInstance';
import Alice from '../Display/Alice';

const SyncTenants = () => {
    const project = usePropsStoreValue('project');
    const { state, dispatch } = useTenantsApp();
    useEffect(() => {
        const fetchTenants = async () => {
            try {
                let [tenants, masterProject] = await Promise.all([
                    getTenantsByProjectId(project._id),
                    getProject(project._id)
                ]);
                dispatch({ type: SET_PROJECT, payload: masterProject });
                dispatch({ type: SET_TENANTS, payload: tenants });
            } catch (error) {
                console.error('Error fetching tenants:', error);
            } finally {
                dispatch({ type: SET_LOADING, payload: false });
            }
        };
        fetchTenants();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (state.loading) return <Loader />;

    if (!state.tenants || state.tenants.length === 0) {
        return (
            <Alice mode="new" header={`Create Tenant`} className="mt-3">
                No tenants found for this project.
                <br /><br />
                Please create a tenant to manage your application instances.
            </Alice>
        );
    }

    return (

        <div className='mt-3 h-100'>
            <div className='col-12 mb-3'>
                <AppInValidBanner />
            </div>
            <div className='col-12 h-100'>
                {state.showDeleteAppDialog && <DeleteTenantApp />}
                {state.showDisableAppDialog && <DisableTenantApp />}
                {state.showSycnAllTenantsDialog && <SyncAllTenantsDialog />}
                {state.showDeleteAppInstanceDialog && <DeleteTenantAppInstance />}
                {state.showDisableAppInstanceDialog && <DisableTenantAppInstance />}
                <TenantsAppGrid />
            </div>
        </div>
    );
}

export default SyncTenants;